export default __webpack_public_path__ + "static/media/proximanova-bold.2c31b16f.otf";